import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BgImg from "../Assets/img/bg-img-1.jpg";
const CallAction = () => {
  const [callActionInfos, setCallActionInfos] = useState([]);
  useEffect(() => {
    axios.get("JSON/callAction.json").then((response) => {
      setCallActionInfos(response.data[0]);
    });
  }, []);
  return (
    <section
      className="eschool-call-action"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <div className="container">
        <div className="col-lg-10 offset-lg-1 col-xl-6 offset-xl-3 col-md-10 offset-md-1 col-12">
          <div className="eschool-cta-content">
            <h3 className="eschool-cta-content-title">
              {callActionInfos?.section_title}
            </h3>
            <p className="eschool-cta-content-text">
              {callActionInfos?.section_detail}
            </p>
            <div className="eschool-cta-content-btn">
              <a
                href={`tel:${callActionInfos?.hotLine}`}
                className="eschool-btn primary"
              >
                <i className="fi fi-rs-call-outgoing"></i> Call us
              </a>
              <Link to="/contactus" className="eschool-btn secondary-btn">
                Contact us <i className="fi fi-rs-arrow-right"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallAction;
